module.exports = __webpack_public_path__ + "static/media/btn_name-the-item.10d49385.png";